import { frontendURL } from "../config/settings-network.mjs";
import UtilsMixin from "../mixins/UtilsMixin";
import http from "../services/http-common";
import { routes } from "./routes";
import { createRouter, createWebHistory } from "vue-router";

import { isTokenValid, scheduleAutoLogout } from "../services/http-common";

const router = createRouter({
  routes,
  //History mode permet d'éviter d'avoir des # dans les urls et
  //d'utiliser des ancres dans les pages (cf documentation)
  //pour éviter d'avoir des erreurs 404 sur les urls du type ../create (le .htaccess a été modifé)
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    // Vue Router 3 used {x, y}; Vue Router 4 reads {left, top} - {x, y} is silently ignored,
    // scrollTo falls back to the current position, and the previous page's scroll sticks.
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        left: 0,
        top: 0,
      };
    }
  },
});

// Routes où on ne redirige pas vers /logout en cas de token expiré (évite boucle infinie)
const ROUTES_SKIP_EXPIRY_CHECK = ["Login", "Logout", "SSOLogout", "CasLogin", "CasLogout", "Error"];

// Planifie l'auto-logout au chargement initial de la page (gère les rafraîchissements)
scheduleAutoLogout();

router.beforeEach((to, from, next) => {
  // Vérification proactive d'expiration du token à chaque navigation
  if (!isTokenValid() && !ROUTES_SKIP_EXPIRY_CHECK.includes(to.name)) {
    localStorage.removeItem("user");
    next(false);
    const url = new URL(`${frontendURL}/logout`);
    url.searchParams.append("messageCode", 1);
    window.location.replace(url.toString());
    return;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // cette route demande une autorisation, vérifions si l'utilisateur est logué.
    // sinon, redirigeons le sur la page de login.
    if (!localStorage.getItem("user")) {
      next({ path: "/error/403" }); // rediriger vers la page de connexion
    } else {
      next();
    }
  } else {
    next(); // assurez vous de toujours appeler `next()` !
  }
});

// Intercepteur Axios pour ajouter le token à chaque requête sortante
http.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.accessToken) {
      config.headers["x-access-token"] = user.accessToken;
    } else {
      config.headers["x-access-token"] = {};
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur Axios pour gérer les erreurs 401 (Non autorisé) et vérifier qu'on est pas déjà sur une page error pour éviter boucle infinie ou que la raison est token expiré
http.interceptors.response.use(
  (response) => response,
  (error) => {
    /* if (
      error.response &&
      error.response.data &&
      (error.response.status === 400 ||
        error.response.status === 401 ||
        error.response.status === 403 ||
        error.response.status === 500) &&
      !window.location.href.includes(`${frontendURL}/error/`) &&
      !window.location.href.includes(`/logout`) &&
      isTokenValid()
    ) {
      // Construire l'URL avec des paramètres de requête
      const errorURL = new URL(`${frontendURL}/error/${error.response.status}`);
      if (error.response.data.messageCode) {
        errorURL.searchParams.append(
          "messageCode",
          error.response.data.messageCode
        );
      }
      if (error.response.data.message) {
        errorURL.searchParams.append("message", error.response.data.message);
      }
      window.location.replace(errorURL.toString());
    } else */
    //Gestion de l'erreur venant du backend signalant qu'un logout GAR a été effectué (donc coté backend) et qu'il faut le répercuter coté client
    if (
      error.response?.status === 401 &&
      error.response?.data?.message == "GAR_LOGOUT"
    ) {
      const logoutURL = new URL(`${frontendURL}/cas/logout`);
      logoutURL.searchParams.append("messageCode", 1);
      window.location.replace(logoutURL.toString());
    } else if (!isTokenValid()) {
      const logoutURL = new URL(`${frontendURL}/logout`);
      logoutURL.searchParams.append("messageCode", 1);
      window.location.replace(logoutURL.toString());
    } else {
      return Promise.reject(error);
    }
  }
);

export default router;

/*
// Intercepteur Axios pour vérifier si la session CAS est terminée
http.interceptors.response.use(
  (response) => {
    if (response.data.message === "End CAS session") {
      console.log("End CAS session");
      localStorage.removeItem("user");
      window.location.replace(`${frontendURL}/cas/logout`);
    }
    return response;
  },
  (error) => Promise.reject(error)
);
*/

/* A été remplacée par la gestion au niveau d'axios car répondant à un besoin plus global
// Ajouter AuthGuard à toutes les routes sauf certaines pour éviter boucles récursives
export function isTokenValidViaAuthGuard(to, from, next) {
  console.log("isTokenValidViaAuthGuard", to, from);
  if (!isTokenValid()) {
    router.push({
      path: "/logout",
      query: {
        returnTo: to.path,
        context: "SESSION_EXPIRED",
      },
    });
  } else {
    next();
  }
}
routes.forEach((route) => {
  const routeWithoutAuthGuard = [
    "Login",
    "Error",
    "CasLogin",
    "Welcome",
    "Logout",
    "SSOLogout",
  ];
  if (!routeWithoutAuthGuard.includes(route.name)) {
    route.beforeEnter = isTokenValidViaAuthGuard;
  }
});
*/

/*
router.beforeEach((to, from, next) => {
  const studentPages = [
    "/studentHome",
    "/results",
    "/sequence/:id",
    "/legalNotices",
    "/dataProtection",
    "/generalConditions",
    "/activity",
  ];
  const authRequired = studentPages.includes(to.path);

  const authSequence = to.path.includes("/sequence/");
  const authActivity = to.path.includes("/activity/");
  console.log("to.path: " + authSequence);

  console.log("authRequired: " + authRequired);

  if (
    isStudent() &&
    authRequired == false &&
    authSequence == false &&
    authActivity == false
  ) {
    next();
  } else {
    next();
  }
});

function isStudent() {
  let permissions = JSON.parse(localStorage.getItem("user"));
  if (permissions && permissions.permissions.length <= 2) {
    console.log("isStudent");
    return true;
  }
  console.log("isNotStudent");
  return false;
}
*/
/*
router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/home', '/explorer', '/create', '/search', '/', '/exemple'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    next();
  }
});
*/
